var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'uik-divider__' + ( _vm.vertical ? 'vertical' : 'horizontal'),
    ( _vm.margin ? 'uik-divider__margin' : '')
]})
}
var staticRenderFns = []

export { render, staticRenderFns }